import React, {  } from 'react';

import { displayNamesOptions } from '../types';
import { DisplayNamesOfInput } from './Intl.DisplayNames';
import { IntlFunction } from './Intl.Function';

export const IntlDisplayNamesOf = () => (
	<IntlFunction
		input={DisplayNamesOfInput}
		mdnLink="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DisplayNames/of"
		header="Intl.DisplayNames.prototype.of"
		description="Receives a code and returns a string based on the locale and options provided when instantiating [Intl.DisplayNames](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DisplayNames) object."
		options={displayNamesOptions}
		ruleSet={[]}
		template="new Intl.DisplayNames(##locale##, ##options##).of(##input##)" />
)